import { Component, OnInit, ɵConsole, ViewChild, TemplateRef } from '@angular/core';
import { CommonService } from '../services/commonService';
import { TranslationLoaderService } from '../services/translationLoader.service';
import { HttpClient } from '@angular/common/http';
import { BaseService } from '../services/base.service';
import { CookieService } from 'ngx-cookie';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { forcedLogout } from '../assets/js/mobilePrint';
import { NavigationEnd, Router } from '@angular/router';
declare var ga: Function;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent extends BaseService implements OnInit {
  @ViewChild('apiErrorStatusModal') apiErrorStatusModal: TemplateRef<any>;

  constructor(
    private translator: TranslationLoaderService,
    private commonService: CommonService,
    http: HttpClient,
    private modalService: NgbModal,
    private _cookieService: CookieService,
    private router: Router
  ) {
    super(http);
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        ga('set', 'page', event.urlAfterRedirects);
        ga('send', 'pageview');
      }
    });
  }
  ngOnInit() {
    this.setTokenFromCookie();
    // this.commonService.setGameIdsArray(JSON.parse(localStorage.getItem("gameIdsArray")));
    this.commonService.gameId().subscribe(res => {
      this.commonService.setGameIdsArray(res.games);
      // localStorage.setItem("gameIdsArray", JSON.stringify(res.games));
    });
    setInterval(() => {
      if (CommonService.apiErrorStatus) {
        if(this._cookieService.get('deviceId') != '' && (this._cookieService.get('deviceId') != undefined || this._cookieService.get('deviceId') != null)) {
          forcedLogout();
        }
        this.modalService.open(this.apiErrorStatusModal);
      }
    }, 1000);
    this.getIPAddress();
  }

  getIPAddress() {
    this.setTokenFromCookie();
    super.http().get("https://api.ipify.org/?format=json").subscribe((res:any)=> {
      if(res.ip != "") {
        this.commonService.setClientIP(res.ip);
      }
    });
  }

  setTokenFromCookie() {
    this.commonService.setAccessToken(this._cookieService.get('TOKEN'));
    if (this._cookieService.get('clientType') != '' && (this._cookieService.get('clientType') != undefined || this._cookieService.get('clientType') != null) && this._cookieService.get("clientType") != "WEB") {
      this.commonService.setClientType(this._cookieService.get('clientType'));
    }
    if(this._cookieService.get('deviceId') != '' && (this._cookieService.get('deviceId') != undefined || this._cookieService.get('deviceId') != null)) {
      this.commonService.setDeviceId(this._cookieService.get('deviceId'));
    }
    if(this._cookieService.get('latitude') != '' && (this._cookieService.get('latitude') != undefined || this._cookieService.get('latitude') != null)) {
      CommonService.latitude = this._cookieService.get('latitude');
      console.log("Latitude value :: " + this._cookieService.get('latitude'));
    }
    if(this._cookieService.get('longitude') != '' && (this._cookieService.get('longitude') != undefined || this._cookieService.get('longitude') != null)) {
      CommonService.longitude = this._cookieService.get('longitude');
      console.log("Longitude value :: " + this._cookieService.get('longitude'));
    }
  }

  closeModal() {
    this.modalService.dismissAll(this.apiErrorStatusModal);
    CommonService.apiErrorStatus = false;
  }

}
